import * as yup from 'yup';

export const supplierConsortiumSchema = yup.object().shape({
  cg_name: yup.string().required('Consortium group name is a required field'),
});
